import { theme } from 'design-cannect'
import styled from 'styled-components'

export const TeacherBiographyContainer = styled.div`
  display: flex;
  gap: 2rem;

  width: 100%;

  img {
    align-self: center;
    width: 200px;
    height: 200px;
    border-radius: 999px;
    margin-bottom: 1rem;
    object-fit: cover;
  }
`

export const TeacherInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  padding: 1.5rem 0;

  h3 {
    color: ${theme.colors.secondary};
    font-size: 1rem;
  }

  p {
    font-weight: 300;
    font-size: 1rem;
  }
`
